import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import { FILTERS_KEY, defaultFiltersState } from '../constants';
import { getShowDetailsPreference, saveShowDetailsPreference } from '../services/localStorageService';
export default function useFilters() {
    const queryClient = useQueryClient();
    const [initialState, setInitialState] = useState(Object.assign(Object.assign({}, defaultFiltersState), { showDetails: getShowDetailsPreference() }));
    // Initialize filters with the stored preference
    useEffect(() => {
        const storedPreference = getShowDetailsPreference();
        setInitialState((prev) => (Object.assign(Object.assign({}, prev), { showDetails: storedPreference })));
    }, []);
    // Function to update the show details preference
    const updateShowDetails = (preference) => {
        // Save to local storage
        saveShowDetailsPreference(preference);
        // Update the query cache
        queryClient.setQueryData(FILTERS_KEY, (oldData) => (Object.assign(Object.assign({}, (oldData || defaultFiltersState)), { showDetails: preference })));
    };
    const query = useQuery({
        queryKey: FILTERS_KEY,
        queryFn: () => initialState,
        staleTime: Infinity,
        initialData: initialState
    });
    return Object.assign(Object.assign({}, query), { updateShowDetails });
}
